export default {
  refresh: 'Refresh PDF',
  refreshHint: 'Creates the report again with the current template and replaces the stored one for everyone.',
  longRunning: {
    summary: 'Creating the audit report',
    detail: 'Creating the report may take a while. Keep this window open. This message closes when the download starts.',
  },
};
